(function() {
  'use strict';
  
  function styleFeedatyWidget() {
    const widgets = document.querySelectorAll('.feedaty_widget');
    if (!widgets || widgets.length === 0) {
      return false;
    }
        
    let sourceWidget = null;
    let sourceContent = null;
    
    for (let i = 0; i < widgets.length; i++) {
      const content = widgets[i].querySelector('.fdt_merchant300x100-2_widget_merchant');
      if (content) {
        sourceWidget = widgets[i];
        sourceContent = content;
        break; 
      }
    }
    
    if (!sourceWidget || !sourceContent) {
      return false;
    }

    const sourceType = sourceWidget.getAttribute('data-type');
    const sourceVariant = sourceWidget.getAttribute('data-variant');

    widgets.forEach(function(widget) {
      if (widget === sourceWidget) {
        return;
      }
      if (widget.getAttribute('data-type') === 'carousel') {
        return;
      }
      if (widget.getAttribute('data-type') !== sourceType || widget.getAttribute('data-variant') !== sourceVariant) {
        return;
      }

      const existingContent = widget.querySelector('.fdt_merchant300x100-2_widget_merchant');
      if (!existingContent) {
        const clonedContent = sourceContent.cloneNode(true);
        widget.innerHTML = '';
        widget.appendChild(clonedContent);
      }
    });
    
    return true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(styleFeedatyWidget, 100);
    });
  } else {
    setTimeout(styleFeedatyWidget, 100);
  }

  setTimeout(styleFeedatyWidget, 500);
  setTimeout(styleFeedatyWidget, 1000);
  setTimeout(styleFeedatyWidget, 1500);
  setTimeout(styleFeedatyWidget, 2000);
  setTimeout(styleFeedatyWidget, 3000);
  setTimeout(styleFeedatyWidget, 4000);
  setTimeout(styleFeedatyWidget, 5000);

  const observer = new MutationObserver(function() {
    styleFeedatyWidget();
  });

  const widgets = document.querySelectorAll('.feedaty_widget');
  if (widgets && widgets.length > 0) {
    widgets.forEach(function(widget) {
      observer.observe(widget, {
        childList: true,
        subtree: true
      });
    });
  }

  let rerenderPending = false;
  function scheduleRerender() {
    if (rerenderPending) return;
    rerenderPending = true;
    setTimeout(function () {
      rerenderPending = false;
      rerenderFeedatyWidgets();
    }, 60);
  }

  const bodyObserver = new MutationObserver(function() {
    const widgets = document.querySelectorAll('.feedaty_widget');
    if (widgets && widgets.length > 0) {
      styleFeedatyWidget();

      let hasEmpty = false;
      widgets.forEach(function(widget) {
        observer.observe(widget, {
          childList: true,
          subtree: true
        });
        const html = (widget.innerHTML || '').trim();
        if (html.length === 0 || html.indexOf('productid required') !== -1) {
          hasEmpty = true;
        }
      });
      if (hasEmpty) scheduleRerender();
    }
  });
  
  bodyObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  function rerenderFeedatyWidgets() {
    if (typeof FeedatyWidget === 'undefined' || typeof FeedatyWidget.init !== 'function') {
      return;
    }
    const empties = Array.from(document.querySelectorAll('.feedaty_widget')).filter(function (w) {
      const html = (w.innerHTML || '').trim();
      return html.length === 0 || html.indexOf('productid required') !== -1;
    });
    if (empties.length === 0) {
      return;
    }
    try {
      FeedatyWidget.init();
    } catch (e) {
      // swallow — Feedaty SDK may not be ready yet
    }
  }

  document.addEventListener('product-info:loaded', function () {
    setTimeout(rerenderFeedatyWidgets, 50);
    setTimeout(rerenderFeedatyWidgets, 300);
    setTimeout(rerenderFeedatyWidgets, 1000);
  });
})();
